var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.0664", cy: "18", r: "18", fill: "#4495E0" },
      }),
      _c("path", {
        attrs: {
          d: "M27.1579 10.9708L26.8603 10.6732L22.9636 6.77651L22.6659 6.4789C22.5312 6.34419 22.3444 6.2666 22.1533 6.2666H10.9507C10.4929 6.2666 10 6.62018 10 7.39605V21.3207V27.7041V27.8828C10 28.2059 10.325 28.5209 10.7095 28.6201C10.7288 28.6251 10.7473 28.6324 10.7674 28.6363C10.8276 28.6483 10.889 28.6548 10.9507 28.6548H26.4194C26.4812 28.6548 26.5426 28.6483 26.6028 28.6363C26.6229 28.6324 26.6414 28.6251 26.6607 28.6201C27.0452 28.5209 27.3702 28.2059 27.3702 27.8828V27.7041V21.3207V11.6622C27.3702 11.3661 27.3347 11.1476 27.1579 10.9708ZM25.9941 10.8986H22.7381V7.6427L25.9941 10.8986ZM10.9507 27.8828C10.9233 27.8828 10.8986 27.8728 10.8743 27.8639C10.8141 27.8353 10.772 27.7751 10.772 27.7041V22.0928H26.5982V27.7041C26.5982 27.7751 26.5561 27.8349 26.4959 27.8639C26.4716 27.8728 26.4468 27.8828 26.4194 27.8828H10.9507ZM10.772 21.3207V7.39605C10.772 7.31229 10.7847 7.03861 10.9507 7.03861H21.9885C21.9758 7.08725 21.9661 7.13743 21.9661 7.18954V11.6707H26.4472C26.4993 11.6707 26.5491 11.661 26.5978 11.6483C26.5978 11.6541 26.5982 11.6564 26.5982 11.6622V21.3207H10.772Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.4604 23.7909C16.2968 23.6188 16.091 23.4802 15.8428 23.3768C15.5946 23.2733 15.3071 23.2212 14.9801 23.2212H13.8086V27.1106H15.2808C15.3298 27.1106 15.4055 27.1044 15.5078 27.092C15.6097 27.0797 15.7224 27.0519 15.8455 27.0075C15.9687 26.9635 16.0961 26.8975 16.2281 26.8095C16.3601 26.7215 16.4786 26.601 16.5843 26.4478C16.6901 26.2946 16.777 26.1046 16.8457 25.8777C16.9144 25.6507 16.9487 25.377 16.9487 25.057C16.9487 24.8247 16.9082 24.5985 16.8275 24.3788C16.7465 24.1596 16.6241 23.9635 16.4604 23.7909ZM15.9988 26.2343C15.8089 26.5088 15.4993 26.6458 15.0701 26.6458H14.442V23.701H14.8114C15.1141 23.701 15.3603 23.7408 15.5502 23.8199C15.7402 23.899 15.8907 24.0028 16.0015 24.1314C16.1123 24.2599 16.1868 24.4031 16.2257 24.5614C16.2644 24.7197 16.2837 24.8798 16.2837 25.0416C16.2837 25.5623 16.1887 25.9603 15.9988 26.2343Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20.3316 23.6645C20.1857 23.4989 20.0151 23.3735 19.8198 23.287C19.6245 23.2006 19.4106 23.1577 19.1787 23.1577C18.9467 23.1577 18.7328 23.2006 18.5375 23.287C18.3422 23.3735 18.1716 23.4989 18.0257 23.6645C17.8797 23.8301 17.7651 24.0366 17.6825 24.2845C17.5999 24.5327 17.5586 24.8202 17.5586 25.1472C17.5586 25.4741 17.5999 25.7629 17.6825 26.0126C17.7651 26.2623 17.8794 26.47 18.0257 26.6352C18.1716 26.8008 18.3422 26.9255 18.5375 27.01C18.7328 27.0946 18.9467 27.1366 19.1787 27.1366C19.4106 27.1366 19.6245 27.0946 19.8198 27.01C20.0151 26.9255 20.1857 26.8008 20.3316 26.6352C20.4776 26.4696 20.5918 26.2623 20.6748 26.0126C20.7574 25.7629 20.7987 25.4741 20.7987 25.1472C20.7987 24.8202 20.7574 24.5323 20.6748 24.2845C20.5918 24.0366 20.4776 23.8301 20.3316 23.6645ZM20.0703 25.8362C20.0174 26.0242 19.9445 26.1767 19.8515 26.2928C19.758 26.409 19.6527 26.4928 19.5349 26.5434C19.4168 26.5943 19.2929 26.6198 19.1628 26.6198C19.0362 26.6198 18.9154 26.5928 18.8011 26.5379C18.6869 26.4831 18.5846 26.3974 18.495 26.2793C18.4055 26.1612 18.3348 26.0095 18.2839 25.8227C18.2329 25.6362 18.2055 25.4112 18.2021 25.1472C18.2055 24.8762 18.2337 24.6477 18.2866 24.4613C18.3395 24.2748 18.4124 24.1227 18.5055 24.0046C18.5985 23.8865 18.7043 23.8035 18.822 23.7541C18.9397 23.7047 19.0636 23.6804 19.1941 23.6804C19.3207 23.6804 19.4411 23.7066 19.5558 23.7595C19.67 23.8124 19.7723 23.8985 19.8619 24.0181C19.9514 24.1378 20.0221 24.2899 20.073 24.4748C20.124 24.6597 20.1514 24.8839 20.1549 25.1476C20.151 25.4185 20.1232 25.6482 20.0703 25.8362Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M22.568 24.0052C22.661 23.8871 22.7668 23.8041 22.8845 23.7547C23.0022 23.7053 23.1261 23.681 23.2566 23.681C23.3728 23.681 23.4843 23.7041 23.5916 23.7497C23.699 23.7952 23.7966 23.8693 23.8846 23.9712L24.3227 23.5806C24.1784 23.4401 24.0147 23.3343 23.8321 23.2641C23.6492 23.1934 23.4523 23.1587 23.2412 23.1587C23.0123 23.1587 22.7996 23.2015 22.6027 23.288C22.4055 23.3745 22.2341 23.4999 22.0882 23.6655C21.9422 23.8311 21.8276 24.0376 21.745 24.2854C21.6624 24.5336 21.6211 24.8212 21.6211 25.1482C21.6211 25.4751 21.6624 25.7638 21.745 26.0136C21.8276 26.2633 21.9419 26.471 22.0882 26.6362C22.2341 26.8018 22.4047 26.9265 22.6 27.011C22.7953 27.0955 23.0092 27.1376 23.2412 27.1376C23.4523 27.1376 23.6492 27.1025 23.8321 27.0322C24.0151 26.9616 24.1784 26.8562 24.3227 26.7157L23.8846 26.3305C23.7931 26.4328 23.692 26.5065 23.5812 26.552C23.4704 26.5976 23.3515 26.6208 23.2249 26.6208C23.0983 26.6208 22.9775 26.5937 22.8633 26.5389C22.749 26.4841 22.6467 26.3984 22.5572 26.2803C22.4676 26.1622 22.397 26.0105 22.346 25.8237C22.2951 25.6372 22.2677 25.4122 22.2642 25.1482C22.2677 24.8772 22.2958 24.6487 22.3487 24.4622C22.4016 24.2758 22.4745 24.1233 22.568 24.0052Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.7024 11.6704H15.0184C15.2315 11.6704 15.4044 11.4975 15.4044 11.2844C15.4044 11.0714 15.2315 10.8984 15.0184 10.8984H12.7024C12.4893 10.8984 12.3164 11.0714 12.3164 11.2844C12.3164 11.4975 12.4893 11.6704 12.7024 11.6704Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.7024 13.6001H16.1764C16.3895 13.6001 16.5624 13.4272 16.5624 13.2141C16.5624 13.0011 16.3895 12.8281 16.1764 12.8281H12.7024C12.4893 12.8281 12.3164 13.0011 12.3164 13.2141C12.3164 13.4272 12.4893 13.6001 12.7024 13.6001Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.7183 13.6011C17.8187 13.6011 17.9191 13.5587 17.9925 13.4891C18.062 13.4157 18.1045 13.3153 18.1045 13.2149C18.1045 13.1145 18.062 13.0141 17.9925 12.9407C17.8496 12.7978 17.5869 12.7978 17.444 12.9407C17.3745 13.0141 17.332 13.1145 17.332 13.2149C17.332 13.3153 17.3745 13.4157 17.444 13.4891C17.5174 13.5587 17.6178 13.6011 17.7183 13.6011Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.2649 13.6001H22.3529C22.566 13.6001 22.7389 13.4272 22.7389 13.2141C22.7389 13.0011 22.566 12.8281 22.3529 12.8281H19.2649C19.0518 12.8281 18.8789 13.0011 18.8789 13.2141C18.8789 13.4272 19.0518 13.6001 19.2649 13.6001Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.4284 18.7307C12.3589 18.8041 12.3164 18.9045 12.3164 19.0049C12.3164 19.1054 12.3589 19.2058 12.4284 19.2792C12.5018 19.3487 12.6022 19.3912 12.7026 19.3912C12.8031 19.3912 12.9035 19.3487 12.9769 19.2792C13.0464 19.2058 13.0889 19.1054 13.0889 19.0049C13.0889 18.9007 13.0464 18.8041 12.9769 18.7307C12.834 18.5878 12.5713 18.5878 12.4284 18.7307Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.3334 18.6187H14.2454C14.0323 18.6187 13.8594 18.7916 13.8594 19.0047C13.8594 19.2177 14.0323 19.3907 14.2454 19.3907H17.3334C17.5465 19.3907 17.7194 19.2177 17.7194 19.0047C17.7194 18.7916 17.5465 18.6187 17.3334 18.6187Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.6697 12.8281H23.8977C23.6846 12.8281 23.5117 13.0011 23.5117 13.2141C23.5117 13.4272 23.6846 13.6001 23.8977 13.6001H24.6697C24.8828 13.6001 25.0557 13.4272 25.0557 13.2141C25.0557 13.0011 24.8828 12.8281 24.6697 12.8281Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.7024 15.5308H21.1945C21.4076 15.5308 21.5805 15.3579 21.5805 15.1448C21.5805 14.9317 21.4076 14.7588 21.1945 14.7588H12.7024C12.4893 14.7588 12.3164 14.9317 12.3164 15.1448C12.3164 15.3579 12.4893 15.5308 12.7024 15.5308Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.6708 14.7588H22.3548C22.1417 14.7588 21.9688 14.9317 21.9688 15.1448C21.9688 15.3579 22.1417 15.5308 22.3548 15.5308H24.6708C24.8839 15.5308 25.0568 15.3579 25.0568 15.1448C25.0568 14.9317 24.8839 14.7588 24.6708 14.7588Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.7024 17.461H14.2464C14.4595 17.461 14.6324 17.288 14.6324 17.075C14.6324 16.8619 14.4595 16.689 14.2464 16.689H12.7024C12.4893 16.689 12.3164 16.8619 12.3164 17.075C12.3164 17.288 12.4893 17.461 12.7024 17.461Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.6484 16.689H15.7883C15.5753 16.689 15.4023 16.8619 15.4023 17.075C15.4023 17.288 15.5753 17.461 15.7883 17.461H19.6484C19.8615 17.461 20.0344 17.288 20.0344 17.075C20.0344 16.8619 19.8615 16.689 19.6484 16.689Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M24.6647 16.689H21.1907C20.9776 16.689 20.8047 16.8619 20.8047 17.075C20.8047 17.288 20.9776 17.461 21.1907 17.461H24.6647C24.8778 17.461 25.0507 17.288 25.0507 17.075C25.0507 16.8619 24.8778 16.689 24.6647 16.689Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }